import * as React from "react";
import { DataGrid, Getter } from "../../../../components/DataGrid/DataGrid";
import { ReportResult } from "../../../../rest/Dashboard/interfaces";
import { DataGridTemplateColumn, Props as TemplateProps } from "../../../../components/DataGrid/DataGridTemplateColumn";
import { Polyglot } from "../../../../polyglot";
import { Spinner } from "../../../../components/Spinner/index";

const styles = require('./ReportGrid.scss');
const tableStyles = require('../../../../components/Table.scss');

interface Props
{
    searchInitiator: string;
    items: ReportResult[];
    polyglot: Polyglot;

    onClick: (category: string) => void;
}

const getTotal: Getter<ReportResult> = r => r.VehiclesTotal;
const getLive: Getter<ReportResult> = r => r.VehiclesLive;
const getDead: Getter<ReportResult> = r => r.VehiclesDead;
const getGreen: Getter<ReportResult> = r => r.VehiclesGreenZone;
const getYellow: Getter<ReportResult> = r => r.VehiclesYellowZone;
const getRed: Getter<ReportResult> = r => r.VehiclesRedZone;
const getUndef: Getter<ReportResult> = r => r.VehiclesUndefinedAlertLevels;

const getRenderFor = (category: string, handler: (category: string) => void) => {
    return ({ datum, getValue }: TemplateProps, className?: string) => {
        const value = getValue(datum) as number;
        return (
            <td>
                { value ? <a className={className} onClick={e => handler(category)}>{value}</a> : null }
            </td>
        );
    };
}

interface CellProps 
{
    category?: string,
    hideZero?: boolean,
    searchInitiator?: string,
    className?: string;
    onClick?: (category: string) => void;
};

const Cell = (props: CellProps & TemplateProps) => {
    const value = props.getValue(props.datum);
    const { category } = props;
    const isLoading = category === props.searchInitiator;
    if(value == null || (value === 0 && props.hideZero)) return <td><span/></td>;
    if(!category || category === '') return <td>{value}</td>;
    return (
        <td>
            { isLoading && <Spinner /> }
            <a className={props.className} style={{ pointerEvents: isLoading ? "none" : "initial" }} onClick={e => props.onClick(props.category)}>{value}</a>
        </td>
    );
};

export class ReportGrid extends React.Component<Props, any>
{
    render()
    {        
        const { polyglot } = this.props;
        return (
            <DataGrid initialData={this.props.items} className={styles.ReportTable}>
                <DataGridTemplateColumn  getValue={getTotal}
                    headerBgColor={"#2f3c43"}
                    headerTextColor={"#FFF"}
                    header={polyglot.t('dashboard.summary_table.column_header.total')}
                    render={colProps => <Cell {...colProps} {...this.props} category="Total"  /> }
                />
                <DataGridTemplateColumn getValue={getLive}
                    headerBgColor={"#FFF"}
                    headerTextColor={"#2f3c43"}
                    header={polyglot.t('dashboard.summary_table.column_header.live')}
                    render={colProps => <Cell {...colProps} {...this.props} category="Live"  />}
                />
                <DataGridTemplateColumn getValue={getDead}
                    headerBgColor={"#FFF"}
                    headerTextColor={"#2f3c43"}
                    header={polyglot.t('dashboard.summary_table.column_header.dead')}
                    render={colProps => <Cell {...colProps} {...this.props} category="Dead" />}
                />
                <DataGridTemplateColumn getValue={getGreen}
                    headerBgColor={"#92c740"}
                    headerTextColor={"#FFF"}
                    header={polyglot.t('dashboard.summary_table.column_header.green_zone')}
                    render={colProps => <Cell {...colProps} {...this.props} category="Green" hideZero/>}
                />
                <DataGridTemplateColumn getValue={getYellow}
                    headerBgColor={"#ecab21"}
                    headerTextColor={"#fff"}
                    header={polyglot.t('dashboard.summary_table.column_header.yellow_zone')}
                    render={colProps => <Cell {...colProps} {...this.props} category="Yellow" hideZero className={styles.SeverityYellow}/> }
                />
                <DataGridTemplateColumn getValue={getRed}
                    headerBgColor={"#bd2728"}
                    headerTextColor={"#fff"}
                    header={polyglot.t('dashboard.summary_table.column_header.red_zone')}
                    render={colProps => <Cell {...colProps} {...this.props} category="Red" hideZero className={styles.SeverityRed} /> }
                />
                <DataGridTemplateColumn getValue={getUndef}
                    headerBgColor={"#bd2728"}
                    headerTextColor={"#fff"}
                    header={polyglot.t('dashboard.summary_table.column_header.no_levels')}
                    render={colProps => <Cell {...colProps} {...this.props} category="VehiclesUndefinedAlertLevels" hideZero className={styles.SeverityRed} /> }
                />
            </DataGrid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Home/ReportGrid.tsx